export default "__VITE_ASSET__65066fd7__"